import { STANDARD_ERROR_MESSAGE } from "../constants";
import getClientSideCSRF from "../getCSRF";
import { getApiUrl } from "./util";

export default async function downloadApiFile(
  appPath: string,
  endpoint: string,
  data: unknown,
): Promise<Blob> {
  const baseUrl = getApiUrl(appPath).replace(/\/$/, "");
  const csrfToken = (await getClientSideCSRF()) || "";
  const response = await fetch(`${baseUrl}/${endpoint.replace(/^\/+/, "")}`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "X-CSRFToken": csrfToken,
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    let errorData: unknown = STANDARD_ERROR_MESSAGE;
    try {
      errorData = await response.json();
    } catch {
      // Keep the standard error message when the response body is not JSON.
    }
    throw { data: errorData, statusCode: response.status };
  }

  return response.blob();
}
